// Insurance master list — RA-Micro Adressnummern + Versicherungsnamen.
// Used for two pickers:
//   * Rechtsschutzversicherung (RSV) — selection stores `nr` (AdressNummer)
//   * Haftpflichtversicherung — selection stores `name` only
//
// Source: Kanzlei M. O. Keller Adressbestand.

export const INSURANCE_LIST = [
  { nr: "1031", name: "Landesamt für Soziales, Jugend und Versorgung" },
  { nr: "1081", name: "DEVK Versicherungen" },
  { nr: "1167", name: "Gothar -Allgemeine Versicherung  AG" },
  { nr: "1270", name: "DBV-Winterthur Versicherung AG" },
  { nr: "1368", name: "Allianz Versicherungs-AG" },
  { nr: "1419", name: "Provinzial Rheinland Versicherung AG" },
  { nr: "1439", name: "DEVK Versicherungen" },
  { nr: "1482", name: "WGV-Schwäbische Allgemeine Versicherung AG" },
  { nr: "1858", name: "Debeka Versicherungen AG" },
  { nr: "1925", name: "Debeka Allgemeine Versicherung AG" },
  { nr: "2553", name: "Hannoversche Volksbank" },
  { nr: "3591", name: "Stadtsparkasse Versmold" },
  { nr: "3602", name: "Volksbank Versmold" },
  { nr: "4356", name: "Volksbank Spiesen-Elversberg" },
  { nr: "5841", name: "Raiffeisenbank Rimpar-Versbach" },
  { nr: "6185", name: "Bundesversicherungsanstalt Berlin" },
  { nr: "6252", name: "Direkt Versicherung" },
  { nr: "6473", name: "Debeka Lebensversicherungs AG" },
  { nr: "6475", name: "Victoria Versicherungen" },
  { nr: "6483", name: "Landesamt für Besoldung und Versorgung NRW" },
  { nr: "6740", name: "keine Rechtsschutzversicherung" },
  { nr: "6741", name: "ADAC Rechtsschutz Versicherungs-AG" },
  { nr: "6742", name: "ADAC-Schutzbrief Versicherungs-AG" },
  { nr: "6743", name: "Agrippina Rechtsschutzversicherung  AG" },
  { nr: "6744", name: "Albingia Rechtsschutzversicherung AG" },
  { nr: "6745", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6746", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6748", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6749", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6750", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6751", name: "Allianz Allgemeine Rechtsschutzvers. AG" },
  { nr: "6752", name: "Allrecht Rechtsschutzversicherung AG" },
  { nr: "6753", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6754", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6755", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6756", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6757", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6758", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6759", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6760", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6761", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6762", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6763", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6764", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6765", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6766", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6767", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6768", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6769", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6770", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6771", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6772", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6773", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6774", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6775", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6776", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6777", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6778", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6779", name: "Debecka Rechtsschutzversicherung" },
  { nr: "6780", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6781", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6782", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6783", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6784", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6785", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6786", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6787", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6788", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6789", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6790", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6791", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6792", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6793", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6794", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6795", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6796", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6797", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6798", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6799", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6800", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6801", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6802", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6803", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6804", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6805", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6806", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6807", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6808", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6809", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6810", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6811", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6812", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6813", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6814", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6815", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6816", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6817", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6818", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6819", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6820", name: "ARAG Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6821", name: "Auxilia Rechtsschutz-Versicherungs AG" },
  { nr: "6822", name: "Badischer Gemeinde-Versicherungs-Verband" },
  { nr: "6823", name: "Ostdeutsche Versicherung AG Bavaria Versicherungsvermittlungs-GmbH" },
  { nr: "6825", name: "CONCORDIA Rechtsschutz-Vers.-AG" },
  { nr: "6826", name: "CORAG Coburger Rechtsschutzvers. AG" },
  { nr: "6827", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6828", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6829", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6830", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6831", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6832", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6833", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6834", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6835", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6836", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6837", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6838", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6839", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6840", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6841", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6842", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6843", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6844", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6845", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6846", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6847", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6848", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6849", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6850", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6851", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6852", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6853", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6854", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6855", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6856", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6857", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6858", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6859", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6860", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6861", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6862", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6864", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6865", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6866", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6867", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6868", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6869", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6870", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6871", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6872", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6873", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6874", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6875", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6876", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6877", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6878", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6879", name: "D.A.S. Allgemeine Rechtsschutz-Vers. AG" },
  { nr: "6880", name: "DBV + Partner Rechtsschutzvers. AG" },
  { nr: "6881", name: "DEURAG Deutsche Rechtsschutz Vers. AG" },
  { nr: "6882", name: "DEURAG Deutsche Rechtsschutz Vers. AG" },
  { nr: "6883", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6884", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6885", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6886", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6887", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6888", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6889", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6890", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6891", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6892", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6893", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6894", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6895", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6896", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6897", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6898", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6899", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "6900", name: "DEUTSCHER MIETERBUND RECHTSSCHUTZ-VERS" },
  { nr: "6901", name: "EA Rechtsschutz-Versicherungs AG" },
  { nr: "6902", name: "Feuerversicherungsanstalt Saarland" },
  { nr: "6903", name: "Versicherungsverband für Gemeinden" },
  { nr: "6905", name: "Hamburg-Mannheimer Rechtsschutzvers. AG" },
  { nr: "6907", name: "Hessische Brandvers.-Anstalt Kassel" },
  { nr: "6908", name: "Hessen-Nassauische Versicherung" },
  { nr: "6909", name: "HRV HANNOVER RECHTSSCHUTZ Vers. AG" },
  { nr: "6910", name: "Karlsruher Rechtsschutzversicherung AG" },
  { nr: "6912", name: "Lippische Landes-Brandvers.-Anstalt" },
  { nr: "6913", name: "LVM Rechtsschutzversicherungs-AG" },
  { nr: "6914", name: "Magdeburger Rechtsschutz Vers.-AG" },
  { nr: "6915", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6916", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6917", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6918", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6919", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6920", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6921", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6922", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6923", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6924", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6925", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6926", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6927", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6928", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6929", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6930", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6931", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6932", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6933", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6934", name: "Mecklenburgische Rechtsschutz-Vers. AG" },
  { nr: "6935", name: "Neue Rechtsschutz Versicherungsges. AG" },
  { nr: "6936", name: "Öffentliche Versicherung Oldenburg" },
  { nr: "6937", name: "ÖRAG Rechtsschutzversicherungs-AG" },
  { nr: "6938", name: "ÖRAG Rechtsschutzversicherungs-AG" },
  { nr: "6939", name: "ÖVA Allgemeine Versicherungs-AG" },
  { nr: "6941", name: "Provinzial Brandkasse Vers.-Anstalt" },
  { nr: "6942", name: "Provinzial-Feuerversicherungsanstalt" },
  { nr: "6943", name: "R + V Rechtsschutzversicherung AG" },
  { nr: "6944", name: "Rechtsschutz Union Versicherungs-AG" },
  { nr: "6945", name: "Rechtsschutz Union Versicherungs-AG" },
  { nr: "6946", name: "Rechtsschutz Union Versicherungs-AG" },
  { nr: "6947", name: "Roland Rechtsschutzversicherung AG" },
  { nr: "6948", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6949", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6950", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6951", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6953", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6954", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6955", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6956", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6957", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6958", name: "ROLAND Rechtsschutz-Versicherungs-AG" },
  { nr: "6959", name: "Volksfürsorge Rechts-Schutz-Vers. AG" },
  { nr: "6961", name: "Winterthur Rechtsschutzversicherungsges" },
  { nr: "6962", name: "Württembergische Rechtsschutzvers. AG" },
  { nr: "6965", name: "ADVOCARD Rechtsschutzversicherung" },
  { nr: "6966", name: "HUK-Coburg-RechtsschutzversicherungsAG" },
  { nr: "6967", name: "Debeka Allg. Vers. AG" },
  { nr: "6968", name: "Württembergische Rechtsschutz Vers. AG" },
  { nr: "6969", name: "R + V Allg. Versicherung AG" },
  { nr: "6971", name: "HDI Rechtsschutz Vers. AG" },
  { nr: "6974", name: "ARAG Allgemeine Rechtsschutzversicherung" },
  { nr: "6976", name: "DA Direkt Versicherung" },
  { nr: "6977", name: "Gothaer Allgemeine Versicherung AG" },
  { nr: "6978", name: "Kraftfahrerschutz Versicherung" },
  { nr: "6980", name: "D.A.S. Versicherungen" },
  { nr: "6981", name: "DMB Rechtsschutz Versicherung AG" },
  { nr: "6982", name: "Aachener und MünchenerVersicherung AG" },
  { nr: "6984", name: "Allianz Versicherungs AG" },
  { nr: "6986", name: "Agrippina Versicherung AG" },
  { nr: "6988", name: "Albingia Versicherung AG" },
  { nr: "6990", name: "Alte Leipziger Versicherung AG" },
  { nr: "6992", name: "D.A.S. Deutscher Automobilschutz Vers. AG" },
  { nr: "6994", name: "AXA Versicherung AG" },
  { nr: "6995", name: "Provinzial Rheinland Versicherung AG" },
  { nr: "6996", name: "Condordia Vers. Ges. a. G" },
  { nr: "6998", name: "D.A.S. Deutscher Automobil Schutz Vers.-AG" },
  { nr: "7000", name: "Cosmos Versicherung AG" },
  { nr: "7002", name: "ARAG Allgemeine Versicherung AG" },
  { nr: "7004", name: "Badischer Gemeinde-Versicherungsverband" },
  { nr: "7006", name: "Barmenia Allgemeine Versicherung AG" },
  { nr: "7008", name: "Basler Versicherungs-Gesellschaft AG" },
  { nr: "7010", name: "Bayerische Beamten Versicherung AG" },
  { nr: "7012", name: "Bruderhilfe Versicherungsverein auf Gegenseitigkeit" },
  { nr: "7014", name: "Colonia Versicherung AG" },
  { nr: "7016", name: "Concordia Versicherungs Gesellschaft auf" },
  { nr: "7018", name: "Condor Allgemeine Versicherung AG" },
  { nr: "7020", name: "Continentale Versicherungsgruppe AG" },
  { nr: "7022", name: "Deutscher Herold Allgemeine Versicherung AG" },
  { nr: "7024", name: "Deutsche Allgemeine Versicherung AG" },
  { nr: "7026", name: "DA Deutsche Allgemeine Versicherung AG" },
  { nr: "7028", name: "Deutsche Beamten Versicherung AG" },
  { nr: "7032", name: "DEVK Allgemeine Vers. AG" },
  { nr: "7034", name: "DEVK Deutsche Eisenbahn Vers. + HUK VersV.a.G" },
  { nr: "7036", name: "PVAG Polizeiversicherungs AG" },
  { nr: "7038", name: "Fahrlehrerversicherung Verein a. G" },
  { nr: "7042", name: "Frankfurter Versicherung AG" },
  { nr: "7044", name: "GARANTA Versicherungs AG" },
  { nr: "7046", name: "GARANTA Versicherungs AG" },
  { nr: "7048", name: "Frankfurter Versicherungs AG" },
  { nr: "7049", name: "Gerling Konzern Allgemeine Versicherung AG" },
  { nr: "7051", name: "Gemeinnützige Haftpflichtversicherung" },
  { nr: "7053", name: "Gothaer Allgemeine Versicherungs AG" },
  { nr: "7055", name: "Gothaer Allgemeine Versicherung AG" },
  { nr: "7057", name: "Hamburg-Mannheimer Sachversicherung AG" },
  { nr: "7059", name: "Hanse-Merkur Allgemeine Versicherungs-AG" },
  { nr: "7061", name: "Hannover Allgemeine Versicherung AG" },
  { nr: "7067", name: "Helvetia Schweizerische Feuerversicherungs-Gesellschaft" },
  { nr: "7069", name: "Deutscher Herold Allgemeine Versicherung AG" },
  { nr: "7071", name: "HNV Hessen-Nassauische Versicherungsanstalt" },
  { nr: "7073", name: "HUK-Coburg Allgemeine Versicherung AG" },
  { nr: "7075", name: "HUK Coburg Versicherungsverein a.G" },
  { nr: "7079", name: "INTER Allgemeine Versicherung AG" },
  { nr: "7083", name: "Karlsruher Versicherungs-AG" },
  { nr: "7085", name: "Kölnische Sachversicherungs-AG" },
  { nr: "7087", name: "Volkswagen-Versicherungsdienst GmbH" },
  { nr: "7089", name: "KRAVAG Versicherung des Deutschen Kraftverkehrs VaG" },
  { nr: "7091", name: "KS Kraftfahrer-Schutz Versicherungs-AG" },
  { nr: "7093", name: "Deutscher Lloyd Versicherung AG" },
  { nr: "7095", name: "LVM Landwirtschaftl. Vers. Verein Münster a.G" },
  { nr: "7097", name: "Mannheimer Versicherungs-G a. G" },
  { nr: "7098", name: "Magdeburger Feuerversicherungs-G" },
  { nr: "7100", name: "Nürnberger Merkur Versicherungs-AG" },
  { nr: "7101", name: "Neckura Neckermann Versicherungs-AG" },
  { nr: "7102", name: "Nordstern Allgemeine Versicherungs-AG" },
  { nr: "7104", name: "Patria Versicherungs-AG" },
  { nr: "7105", name: "Provinzial-Rheinland Vers. AG" },
  { nr: "7107", name: "R+V Allgemeine Versicherungs-AG" },
  { nr: "7108", name: "R + V Allgemeine Versicherungs AG" },
  { nr: "7109", name: "Rheinland Versicherungs-AG" },
  { nr: "7110", name: "Deutscher Ring Sachversicherung AG" },
  { nr: "7112", name: "Saar-Union Allgemeine Versicherungs-AG" },
  { nr: "7113", name: "Schweizer National Versicherungs-AG" },
  { nr: "7114", name: "Securitas Bremer Allgemeine Versicherung AG" },
  { nr: "7116", name: "Skandia Versicherungs-AG Stockholm" },
  { nr: "7117", name: "Thuringia Gemnerali Versicherung AG" },
  { nr: "7119", name: "Thuringia Generali Versicherung AG" },
  { nr: "7121", name: "Transatlantische Sachversicherungs-AG" },
  { nr: "7122", name: "Universa Versicherungs-AG" },
  { nr: "7123", name: "Vödag Versicherung" },
  { nr: "7124", name: "VdK Versicherung d. Kraftfahrt AG" },
  { nr: "7125", name: "Versicherungsverband Deutsche Eisenbahn a.G" },
  { nr: "7127", name: "Vereinigte Haftpflicht Versicherung a.G" },
  { nr: "7129", name: "Vereinigte Haftpflicht Versicherung a.G" },
  { nr: "7131", name: "Victoria Feuer-Versicherungs-AG" },
  { nr: "7132", name: "Victoria Feuer-Versicherungs-AG" },
  { nr: "7134", name: "Voedag Versicherung im Adler-Inuna Verbund" },
  { nr: "7135", name: "Volksfürsorge dt. Sachversicherungs-AG" },
  { nr: "7137", name: "Volkswohl Deutsche Sachversicherungs-AG" },
  { nr: "7141", name: "Würtenbergische Rechtsschutzversicherungs AG" },
  { nr: "7143", name: "WWK Allgemeine Versicherungs-AG" },
  { nr: "7145", name: "Zenith Versicherungs-AG" },
  { nr: "7149", name: "Zürich Versicherungs-Gesellschaft" },
  { nr: "7150", name: "Opel-Händler Versicherungsdienst gmbH" },
  { nr: "7153", name: "Hamburg-Mannheimer Sachvers. AG" },
  { nr: "7155", name: "Allianz Versicherungs AG" },
  { nr: "7157", name: "ProvinzialRheinland Vers., AG" },
  { nr: "7159", name: "Gerling G & A Vers. AG" },
  { nr: "7161", name: "DBV-Winterthur Versicherung AG" },
  { nr: "7163", name: "GVV-Privatversicherung AG" },
  { nr: "7165", name: "GVV Kommunalversicherung VVaG" },
  { nr: "7167", name: "EUROPA Sachversicherungs AG" },
  { nr: "7169", name: "EUROPA Sachversicherungs AG Direktion" },
  { nr: "7171", name: "EUROPA Sachversicherungs AG" },
  { nr: "7177", name: "Zürich Versicherungs AG" },
  { nr: "7179", name: "NOVA Allgem. Vers. AG" },
  { nr: "7181", name: "NOVA Allgem.Vers. AG" },
  { nr: "7183", name: "AXA Versicherungs AG" },
  { nr: "7185", name: "AXA Versicherungs AG" },
  { nr: "7187", name: "AXA Versicherung AG" },
  { nr: "7189", name: "Gothaer Allgemeine Vers. AG" },
  { nr: "7191", name: "Debeka Allgemeine Versicherungs AG" },
  { nr: "7193", name: "AachenMünchener Versicherung AG" },
  { nr: "7195", name: "S Direkt Versicherung AG" },
  { nr: "7197", name: "DEVK Allgemeine Versicherungs AG" },
  { nr: "7199", name: "ADAC Versicherungs AG" },
  { nr: "7201", name: "KRAVAG Allgemeine Versicherungs AG" },
  { nr: "7203", name: "Mecklenburgische Vers. Ges. a.G" },
  { nr: "7205", name: "Württembergische Versicherung AG" },
  { nr: "7207", name: "Allianz - Frankfurter Vers. AG" },
  { nr: "7209", name: "Aachener und Münchener Vers. AG" },
  { nr: "7211", name: "Aachener und Münchener Vers. AG" },
  { nr: "7213", name: "Aachener und Münchener Vers. AG" },
  { nr: "7215", name: "ADLER Vers. AG" },
  { nr: "7217", name: "ADLER Vers. AG (Direktion)" },
  { nr: "7219", name: "Allianz Versicherungs AG" },
  { nr: "7221", name: "Allianz Versicherungs AG" },
  { nr: "7223", name: "Allianz Versicherungs AG" },
  { nr: "7225", name: "Allianz Versicherungs AG" },
  { nr: "7227", name: "Württembergische Vers. AG" },
  { nr: "7231", name: "Bayeriche Allianz Vers. AG" },
  { nr: "7237", name: "KRAVAG-Logistic Vers. AG" },
  { nr: "7243", name: "Provinzial Rheinland Versicherung AG" },
  { nr: "7245", name: "Continentale Sachversicherung AG" },
  { nr: "7247", name: "HDI Global Versicherung AG" },
  { nr: "7249", name: "Allianz Versicherungs-Atkiengesellschaft" },
  { nr: "7251", name: "Helvetia Schweizerische Versicherungsgesellschaft" },
  { nr: "7253", name: "Allianz Versicherungs AG" },
  { nr: "7255", name: "D.A.S. Versicheurngen" },
  { nr: "7257", name: "S direkt Versicherung AG" },
  { nr: "7260", name: "Concordia Versicherung" },
  { nr: "7263", name: "R+V Allgemeine Versicherung AG" },
  { nr: "7300", name: "Aggertaler Briefmarkenversand GmbH" },
  { nr: "7308", name: "Securitas Bremer Allg. Vers. AG" },
  { nr: "7493", name: "KZVK Kirchliche Zusatzversorgungskasse" },
  { nr: "7529", name: "Europäische Reisevers. AG" },
  { nr: "7634", name: "A Versteeg GmbH" },
  { nr: "7698", name: "VPV Allg. Versicherungs-AG" },
  { nr: "7702", name: "Regionaldirektion Schaden-Service DAS Versicherungen" },
  { nr: "7733", name: "Rheinischer Gemeindeunfallversicherungsverband" },
  { nr: "7742", name: "Aachener u. Münchener Versicherung AG" },
  { nr: "7808", name: "Gerling-Konzern Allgemeine Versicherungs-AG" },
  { nr: "7899", name: "Volksfürsorge Deutsche Sachversicherungs AG" },
  { nr: "8011", name: "Stuttgarter Versicherung AG" },
  { nr: "8145", name: "Central Krankenversicherung AG" },
  { nr: "8356", name: "DKV Deutsche Krankenversicherung AG" },
  { nr: "8432", name: "Universum Inkasso GmbH" },
  { nr: "8462", name: "DEVK Versicherung AG" },
  { nr: "8506", name: "Generali Vers.AG" },
  { nr: "8574", name: "Deutsche Rentenversicherung Rheinland" },
  { nr: "8656", name: "RheinLand Versicherungs AG" },
  { nr: "8695", name: "ADAC Autoversicherung AG" },
  { nr: "8904", name: "Frankfurter Vers. AG" },
  { nr: "9472", name: "Württembergische Versicherung AG" },
  { nr: "9495", name: "R+V Allgemeine Versicherung AG" },
  { nr: "9516", name: "Universum Inkasso" },
  { nr: "9585", name: "LVM Versicherungen" },
  { nr: "9608", name: "D.A.S. Rechtsschutzversicherung" },
  { nr: "9627", name: "Zurich Rechtschutzversicherung" },
  { nr: "9634", name: "ERGO Versicherung AG" },
  { nr: "9826", name: "Deutsche Rentenversicherung Bund" },
  { nr: "9896", name: "ERGO Lebensversicherungs AG" },
  { nr: "9926", name: "OVAG - Ostdeutsche Versicherung AG" },
  { nr: "9940", name: "DEVK Rechtsschutz-Versicherungs-AG" },
  { nr: "9983", name: "Euler Hermes Kreditversicherungs AG" },
  { nr: "10022", name: "Universal Music GmbH" },
  { nr: "10320", name: "D.A.S. Rechtsschutzversicherung" },
  { nr: "10357", name: "Reversus GmbH" },
  { nr: "10378", name: "Volkswagen Versicherungsdienst GmbH" },
  { nr: "10448", name: "Allianz Versicherung AG" },
  { nr: "10487", name: "Gemeinnützige Haftpflichtversicherungsanstalt d. Gartenbau-Berufsgen." },
  { nr: "10502", name: "NORDVERS GmbH" },
  { nr: "10632", name: "Universitätsklinikum Bonn" },
  { nr: "10686", name: "HDI-Gerling Firmen und Privat Versicherung AG" },
  { nr: "10791", name: "Sanicare Apotheke - Krankenhausversorgung" },
  { nr: "10801", name: "Deutsche Rentenversicherung Rheinland" },
  { nr: "10920", name: "Axa Versicherung AG" },
  { nr: "10959", name: "Ammerländer Versicherung VVaG" },
  { nr: "10999", name: "KRAVAG Allgemeine Versicherungs AG" },
  { nr: "11080", name: "Zürich Versicherung AG" },
  { nr: "11165", name: "D.A.S. Deutscher Automobil Schutz Allgemeine Rechtschutz-Versicherungs-AG" },
  { nr: "11207", name: "Provinzial Rechtsschutzversicherungs-AG" },
  { nr: "11212", name: "HDI-Gerling Versicherungs-AG" },
  { nr: "11361", name: "VBG Ihre gesetzliche Unfallversicherung" },
  { nr: "11393", name: "VBG - Gesetzliche Unfallversicherung" },
  { nr: "11412", name: "Deutsche Rentenversicherung Bund" },
  { nr: "11432", name: "IDEAL Versicherung AG" },
  { nr: "11484", name: "Deutsche Rentenversicherung Bund" },
  { nr: "11498", name: "Union Krankenversicherung AG" },
  { nr: "11651", name: "Verti Versicherung AG" },
  { nr: "11720", name: "HUK-Coburg Versicherung AG" },
  { nr: "11868", name: "ADAC Autoversicherung AG" },
  { nr: "11885", name: "HDI-Gerling Industrie Versicherung AG" },
  { nr: "11902", name: "Mecklenburgische Versicherung" },
  { nr: "11936", name: "DBV Deutsche Beamtenversicherung AG" },
  { nr: "11948", name: "Universitätsklinikum Bonn" },
  { nr: "11975", name: "Verspui Trucks GmbH" },
  { nr: "12433", name: "SparkassenDirekt Versicherung AG" },
  { nr: "12579", name: "SanVersZentrum Rennerod" },
  { nr: "12699", name: "KRAVAG-LOGISTIC Versicherungs-AG" },
  { nr: "12894", name: "Debeka Krankenversicherungsverein a.G." },
  { nr: "13036", name: "R+V24 Versicherung" },
  { nr: "13040", name: "ADAC Schutzbrief Vers.-AG" },
  { nr: "13083", name: "Deutsche Rentenversicherung Bund" },
  { nr: "13172", name: "Versorgungswerk der Rechtsanwälte NRW" },
  { nr: "13245", name: "Universitätklinikum Bonn" },
  { nr: "13317", name: "Bruderhilfe Sachversicherung AG im Raum der Kirchen" },
  { nr: "13353", name: "HanseMerkur Krankenversicherung AG" },
  { nr: "13427", name: "Universitätsklinikum Bonn" },
  { nr: "13540", name: "Universitätsklinikum Bonn" },
  { nr: "13541", name: "Universitätsklinikum Bonn" },
  { nr: "13650", name: "CosmosDirekt Versicherung AG" },
  { nr: "13680", name: "SV SparkassenVersicherung, Gebäudeversicherung AG" },
  { nr: "13963", name: "Röder - Kfz-Sachverständigenbüro" },
  { nr: "13999", name: "Volkswagen Versicherungsdienst GmbH" },
  { nr: "14104", name: "Sachverständigenbüro Hermanns" },
  { nr: "14290", name: "TARGO Versicherung AG" },
  { nr: "14306", name: "KRAVAG-LOGISTIC Versicherungs-AG" },
  { nr: "14736", name: "Zurich Versicherung AG" },
  { nr: "14772", name: "Zentralruf der Autoversicherer" },
  { nr: "15339", name: "Rheinische Elektrizitäts- und Gasversorgungsgesellschaft mbH" },
  { nr: "15602", name: "Universitätsklinikum Bonn" },
  { nr: "15740", name: "Ford Versicherungs-Vermittlungs-GmbH (FVV)" },
  { nr: "15813", name: "Deutsche Rentenversicherung Rheinland" },
  { nr: "15843", name: "Altenkirchener Bedachungen & Sachverständigenbüro UG" },
  { nr: "15846", name: "K. Schröder Dachdeckerei und Sachverständigenbüro UG & Co. KG" },
  { nr: "15955", name: "R+V Allgemeine Versicherung AG" },
  { nr: "16094", name: "Carexpert Kfz-Sachverständigen GmbH" },
  { nr: "16149", name: "Generali Deutschland Versicherung AG" },
  { nr: "16235", name: "BEV Bayerische Energieversorgungsgesellschaft mbH" },
  { nr: "16287", name: "Versicherer im Raum der Kirchen" },
  { nr: "16484", name: "Deutsche Rentenversicherung Westfalen" },
  { nr: "16550", name: "VRK Sachversicherung" },
  { nr: "16570", name: "Kfz.-Sachverständigenbüro Landgraf" },
  { nr: "16634", name: "MONTANA Energieversorgung GmbH & Co. KG" },
  { nr: "16772", name: "Energieversorgung Mittelrhein AG" },
  { nr: "16776", name: "SV SparkassenVersicherung, Gebäudeversicherung AG" },
  { nr: "17025", name: "Baur Versand GmbH & Co. KG" },
  { nr: "17173", name: "Universitätsklinikum Köln" },
  { nr: "17475", name: "Rhion Versicherung AG" },
  { nr: "17829", name: "Kfz-Schverständigenbüro Pohl" },
  { nr: "17830", name: "Kfz-Sachverständigenbüro Jansen" },
  { nr: "18133", name: "Allianz Direct Versicherungs-AG" },
];

/**
 * Internal: aggressive normalization for dedup.
 * Goal: collapse entries that are clearly the same company but written
 * with different case / whitespace / punctuation / common abbreviations:
 *   - case-insensitive
 *   - all whitespace, hyphens, commas, dots, slashes removed
 *   - trailing legal-form suffix "AG"/"VVaG"/"aG" stripped
 *   - "Versicherungs(?)" / "Versicherung" collapsed to "vers"
 *
 * Examples that merge:
 *   "ROLAND Rechtsschutz-Versicherungs-AG"
 *   "Roland Rechtsschutzversicherung AG"
 *   "roland rechtsschutzvers ag"
 *   → all collapse to "rolandrechtsschutzvers"
 */
const _normalize = (raw) => {
  let s = (raw || "").toLowerCase();
  // strip punctuation + whitespace
  s = s.replace(/[^a-z0-9äöüß]/g, "");
  // strip trailing legal-form suffixes (multiple passes for stacked forms)
  for (let i = 0; i < 4; i++) {
    s = s.replace(/(vvag|ag|gmbh|kg|gbr|ev)$/, "");
  }
  // collapse "versicherung(s)?" → "vers"
  s = s.replace(/versicherungs?/g, "vers");
  // again strip any trailing ag/vvag etc. after the collapse
  for (let i = 0; i < 4; i++) {
    s = s.replace(/(vvag|ag|gmbh|kg|gbr|ev)$/, "");
  }
  return s;
};

/**
 * Pattern test: is this an actual Rechtsschutzversicherung?
 * Matches names that contain "Rechtsschutz" / "Rechtschutz" / "Rechts-Schutz"
 * (case-insensitive, with optional separator).
 */
const _isRechtsschutz = (name) =>
  /recht[s]?[\s\-]?schutz/i.test(name || "");

const _NON_INSURANCE_NRS = new Set([
  // Spezialeintrag (keine echte Versicherung)
  "6740",
  // Banken / Sparkassen
  "2553", "3591", "3602", "4356", "5841",
  // Behörden / Ämter / Renten (alle Varianten)
  "1031", "6185", "6483", "8574", "9826", "10801", "11412", "11484",
  "13083", "15813", "16484",
  // Kliniken / Apotheken (alle Varianten)
  "10632", "10791", "11948", "13245", "13427", "13540", "13541", "15602",
  "17173",
  // Sachverständigenbüros / Bedachung / Dachdecker
  "13963", "14104", "15843", "15846", "16094", "16570", "17829", "17830",
  // Energie / Versorger
  "15339", "16235", "16634", "16772",
  // Inkasso / Vermittler
  "6823", "8432", "9516", "10502",
  // Sonstige Firmen / Versorgungswerke
  "7300", "7493", "7634", "10022", "10357", "11975", "12579", "13172",
  "14772", "17025",
]);

/**
 * Build the master list, dedupliziert (case+punctuation insensitive),
 * Nicht-Versicherungen entfernt. List for Haftpflicht-Auswahl.
 */
const _dedupeForHaftpflicht = (list) => {
  const seen = new Set();
  const out = [];
  for (const item of list) {
    if (_NON_INSURANCE_NRS.has(item.nr)) continue;
    const key = _normalize(item.name);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
};

/**
 * Build the RSV-only list — same dedup + non-insurance filter, PLUS:
 *   - only entries that match the Rechtsschutz pattern
 *   - the special entry "keine Rechtsschutzversicherung" (Nr 6740) is kept
 */
const _dedupeForRSV = (list) => {
  const seen = new Set();
  const out = [];
  for (const item of list) {
    if (_NON_INSURANCE_NRS.has(item.nr)) continue;
    if (!_isRechtsschutz(item.name)) continue;
    const key = _normalize(item.name);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
};

const INSURANCE_LIST_HAFTPFLICHT = _dedupeForHaftpflicht(INSURANCE_LIST);
const INSURANCE_LIST_RSV = _dedupeForRSV(INSURANCE_LIST);

export const filterInsurances = (query, limit = 30, mode = "haftpflicht") => {
  const pool = mode === "rsv" ? INSURANCE_LIST_RSV : INSURANCE_LIST_HAFTPFLICHT;
  const q = (query || "").toLowerCase().trim();
  if (!q) return pool.slice(0, limit);
  return pool.filter(
    (i) =>
      i.nr.toLowerCase().includes(q) ||
      i.name.toLowerCase().includes(q)
  ).slice(0, limit);
};

/**
 * Helper: derive categories that need the Haftpflicht question.
 * Based on user spec.
 */
export const HAFTPFLICHT_CATEGORIES = [
  "Verkehrsrecht",
  "Arbeitsrecht",
  "Mietrecht",
  "Zivilrecht",
  "Sonstige",
];

export const needsHaftpflicht = (category) =>
  HAFTPFLICHT_CATEGORIES.includes(category);

/**
 * Helper: decide if the Gegenseite (opponent) step must be shown.
 * Skipped for Strafrecht, Bußgeld, and Vertragsrecht except "Vertragskündigung".
 */
export const needsOpponentStep = (category, subcategory) => {
  if (!category) return true; // default
  if (category === "Strafrecht") return false;
  if (category === "Bußgeld") return false;
  if (category === "Vertragsrecht") {
    return subcategory === "Vertragskündigung";
  }
  return true;
};

/**
 * Helper: decide if the PKH/VKH section is shown.
 * Only for Familien- & Erbrecht.
 */
export const needsPKH = (category) => category === "Familien- & Erbrecht";
